import { useState, useEffect, useRef } from 'react'
import { MultiSelect } from "primereact/multiselect";
import { Urls } from "../../../services/Urls.js";
import services from "../../../services/services.js";
import _ from "underscore";
import PanelHeaderTemplate from "../PanelHeadeTemplate/PanelHeaderTemplate.jsx";


const CommonDropdown = ({ placeholder, value, selectedValues, isFilterChange, selectedProject, projectFilter }) => {
    const [options, setOptions] = useState([]);
    const [values, setvalues] = useState([]);
    const [isChanged, setisChanged] = useState(false);
    const [optionLabel, setoptionLabel] = useState([]);
    const selectedData = useRef([])


    useEffect(() => {
        if (value === 'project_module') {
            getProjectModule()
        }
        else if (value === 'subproject_module') {
            getSubProjectModule()
        }
        else if (value === 'epic') {
            getEpic()
        }
        // eslint-disable-next-line
    }, []);



    useEffect(() => {
        if (isFilterChange && value === 'project_module') {
            getProjectModule()
        }
        if (isFilterChange && value === 'subproject_module') {
            getSubProjectModule()
        }
        if (isFilterChange && value === 'epic') {
            getEpic()
        }
        // eslint-disable-next-line
    }, [isFilterChange, value]);


    const getProjectModule = async () => {
        const projectId = _.pluck(selectedProject, 'project_id')
        const payload = {
            "project_ids": selectedProject?.length > 0 ? projectId.toString() : ''
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTMODULE'), payload);
            setOptions(_.sortBy(res.body.data.project_module, 'option_value'))
            setoptionLabel('option_value')
            if (_.isEmpty(res.body.data.project_module)) {
                // selectedValues('project_module', []) 
                projectFilter('project_module', [])
                setvalues([])
            } else {
                let tempArray = []
                values.forEach(val => {
                    const isSelectedData = _.findWhere(res.body.data.project_module, val)
                    if (!_.isEmpty(isSelectedData)) {
                        tempArray.push(isSelectedData)
                    }
                })
                setvalues(tempArray)
                projectFilter('project_module', tempArray)
            }

        }
        catch (error) {
            console.error(error, "error");
            projectFilter('project_module', [])
        }

    }


    const getSubProjectModule = async () => {
        const projectId = _.pluck(selectedProject, 'project_id')
        const payload = {
            "project_ids": selectedProject?.length > 0 ? projectId.toString() : ''
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETSUBPROJECT'), payload);
            setoptionLabel('option_value')
            setOptions(_.sortBy(res.body.data.sub_project, 'option_value'))
            if (_.isEmpty(res.body.data.sub_project)) {
                projectFilter('subproject_module', [])
                setvalues([])
            } else {
                let tempArray = []
                values.forEach(val => {
                    const isSelectedData = _.findWhere(res.body.data.sub_project, val)
                    if (!_.isEmpty(isSelectedData)) {
                        tempArray.push(isSelectedData)
                    }
                })
                setvalues(tempArray)
                projectFilter('subproject_module', tempArray)
            }
        }
        catch (error) {
            console.error(error, "error");
            projectFilter('subproject_module', [])
        }

    }


    const getEpic = async () => {
        if (selectedProject?.length !== 0) {
            const projectId = _.pluck(selectedProject, 'project_id')
            const payload = {
                "project_ids": selectedProject?.length > 0 ? projectId.toString() : ''
            }
            try {
                const res = await services.getInvokeRemote('POST', Urls('GETEPIC'), payload);
                setoptionLabel('issue_summary')
                setOptions(selectedProject?.length === 0 ? [] : _.sortBy(res.body.data.epic_data, 'issue_summary'))
                if (selectedProject?.length === 0) {
                    projectFilter('epic', [])
                    setvalues([])
                } else {
                    let tempArray = []
                    values.forEach(val => {
                        const isSelectedData = _.findWhere(res.body.data.epic_data, val)
                        if (!_.isEmpty(isSelectedData)) {
                            tempArray.push(isSelectedData)
                        }
                    })
                    setvalues(tempArray)
                    projectFilter('epic', tempArray)
                }
            }

            catch (error) {
                console.error(error, "error");
                projectFilter('epic', [])
            }
        } else if (selectedProject?.length === 0) {
            projectFilter('epic', [])
            setvalues([])
            setOptions([])
        }


    }

    const selectedValuesToSend = (key) => {
        if (key === 'reset') {
            selectedValues(key, value)
            setisChanged(false)
        } else {
            selectedValues(key, values)
            setisChanged(false)
        }
    }
    const selectedItemsTemplate = (option) => {
        if (option) {
            if (option.length === 1) {
                return option[0][optionLabel];
            }
            else {
                return `${option.length} items selected`;
            }
        }

        return placeholder;
    };


    return (
        <div>
            <MultiSelect options={options} optionLabel={optionLabel} placeholder={placeholder}
                onChange={(e) => {
                    setisChanged(true)
                    setvalues(e.value);
                    selectedData.current = e.value;
                }}
                value={values}
                onHide={() => { isChanged && selectedValuesToSend(value) }}
                filter
                selectedItemTemplate={selectedItemsTemplate}
                panelHeaderTemplate={(options) => PanelHeaderTemplate(options, value, values, setvalues, selectedValuesToSend, value)}
            />

        </div>
    )
}

export default CommonDropdown
